// Mock data para Sofia Investe - Plataforma de Trading

export const mockData = {
  // Hero Section
  hero: {
    title: "Negocie Forex com uma Mesa Proprietária Profissional",
    subtitle: "Plataforma regulada pela FSA com TradingView integrado para opções binárias. Entre na arena e conquiste seus objetivos financeiros.",
    cta: "Começar Agora",
    secondaryCta: "Conhecer Recursos"
  },

  // Features
  features: [
    {
      id: 1,
      icon: "TrendingUp",
      title: "Mesa Proprietária",
      description: "Opere com nossa mesa proprietária em opções binárias e maximize seus lucros com tecnologia de ponta."
    },
    {
      id: 2,
      icon: "BarChart3",
      title: "TradingView Integrado",
      description: "Análises técnicas avançadas com a melhor plataforma de gráficos do mercado, integrada diretamente."
    },
    {
      id: 3,
      icon: "Shield",
      title: "Regulada pela FSA",
      description: "Segurança e confiabilidade garantidas. Somos regulados pela Financial Services Authority."
    },
    {
      id: 4,
      icon: "Zap",
      title: "Execução Instantânea",
      description: "Orders executadas em milissegundos. Não perca oportunidades por atrasos na plataforma."
    },
    {
      id: 5,
      icon: "LineChart",
      title: "Análise em Tempo Real",
      description: "Dados de mercado atualizados instantaneamente para decisões mais precisas e lucrativas."
    },
    {
      id: 6,
      icon: "Users",
      title: "Comunidade Ativa",
      description: "Faça parte de uma comunidade de traders vencedores. Compartilhe estratégias e aprenda."
    }
  ],

  // Pricing Plans
  pricingPlans: [
    {
      id: 1,
      name: "Iniciante",
      price: "R$ 297",
      period: "/mês",
      description: "Perfeito para quem está começando",
      features: [
        "Acesso à plataforma básica",
        "TradingView Essential",
        "Suporte por email",
        "Materiais educacionais",
        "1 conta demo"
      ],
      highlighted: false,
      cta: "Começar Agora"
    },
    {
      id: 2,
      name: "Profissional",
      price: "R$ 697",
      period: "/mês",
      description: "Para traders experientes",
      features: [
        "Acesso completo à plataforma",
        "TradingView Pro",
        "Suporte prioritário 24/7",
        "Sinais de trading premium",
        "3 contas demo",
        "Webinars exclusivos",
        "Análises personalizadas"
      ],
      highlighted: true,
      cta: "Mais Popular"
    },
    {
      id: 3,
      name: "Elite",
      price: "R$ 1.497",
      period: "/mês",
      description: "Para traders profissionais",
      features: [
        "Plataforma completa premium",
        "TradingView Premium",
        "Gerente de conta dedicado",
        "Sinais VIP em tempo real",
        "Contas demo ilimitadas",
        "Mentoria individual",
        "API para trading automatizado",
        "Cashback em operações"
      ],
      highlighted: false,
      cta: "Entrar em Contato"
    }
  ],

  // Testimonials
  testimonials: [
    {
      id: 1,
      name: "Carlos Silva",
      role: "Trader Profissional",
      content: "A Sofia Investe transformou minha forma de operar. A mesa proprietária e o TradingView integrado fazem toda a diferença. Meus resultados aumentaram 300% em 6 meses.",
      rating: 5,
      avatar: "CS"
    },
    {
      id: 2,
      name: "Maria Santos",
      role: "Day Trader",
      content: "Finalmente uma plataforma regulada que entende traders. O suporte é excepcional e a execução é instantânea. Recomendo de olhos fechados!",
      rating: 5,
      avatar: "MS"
    },
    {
      id: 3,
      name: "João Oliveira",
      role: "Investidor",
      content: "Estava cansado de plataformas amadoras. Na Sofia Investe encontrei profissionalismo, segurança e as ferramentas certas para crescer no mercado forex.",
      rating: 5,
      avatar: "JO"
    }
  ],

  // Stats
  stats: [
    {
      id: 1,
      value: "10K+",
      label: "Traders Ativos"
    },
    {
      id: 2,
      value: "R$ 50M+",
      label: "Volume Negociado"
    },
    {
      id: 3,
      value: "99.9%",
      label: "Uptime"
    },
    {
      id: 4,
      value: "24/7",
      label: "Suporte"
    }
  ],

  // Footer
  footer: {
    company: {
      name: "Sofia Investe",
      description: "Mesa proprietária de trading regulada pela FSA. Negocie forex com profissionalismo e segurança."
    },
    links: {
      product: [
        { label: "Plataforma", href: "#plataforma" },
        { label: "Planos", href: "#planos" },
        { label: "API", href: "#api" }
      ],
      company: [
        { label: "Sobre", href: "#sobre" },
        { label: "Blog", href: "#blog" },
        { label: "Carreiras", href: "#carreiras" }
      ],
      legal: [
        { label: "Termos", href: "#termos" },
        { label: "Privacidade", href: "#privacidade" },
        { label: "Regulação FSA", href: "#regulacao" }
      ]
    },
    social: [
      { platform: "Twitter", url: "#" },
      { platform: "LinkedIn", url: "#" },
      { platform: "Instagram", url: "#" },
      { platform: "Youtube", url: "#" }
    ]
  }
};

// Mock function for form submission
export const mockSubmitWaitlist = async (data) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // Simulate 90% success rate
  if (Math.random() > 0.1) {
    console.log('Waitlist submission (MOCK):', data);
    return {
      success: true,
      message: 'Cadastro realizado com sucesso! Entraremos em contato em breve.'
    };
  } else {
    throw new Error('Erro ao processar cadastro. Tente novamente.');
  }
};
